export const defaultValueSymbol: symbol = Symbol("defaultValue");
